import Service from "../services/Service";
import ScriptEngine from "./ScriptEngine";
import * as ScriptConst from "./ScriptEngine";
import EQScript from "../../public-apis/onclick/EQScript";
import StepConfigFactory from "./StepConfigFactory";

/**
 * Manage scripts
 */
export default class ScriptService extends Service {

    /**
     * Default constructor
     *
     * @param {number} uid
     * @param {Config} configuration
     * @param {GpsService} gpsService
     * @param {DeviceService} deviceService
     * @param {GatewayService} gatewayService
     */
    constructor(uid, configuration, gpsService, deviceService, gatewayService) {
        super();
        this.uid = uid;
        this.configuration = configuration;
        this.scripts = new Map();
        this.gpsService = gpsService;
        this.deviceService = deviceService;
        this.gatewayService = gatewayService;
    }

    /**
     * Public API to get all scripts available
     *
     * @return {Array} list of scripts from the config (with less information for UI)
     */
    getScripts() {
        const scripts = [];
        if (this.configuration.scenarios) {
            this.configuration.scenarios.forEach((scenario) => {

                // Fix EWA-31
                let steps = new Array();
                if (scenario.steps) {
                    scenario.steps.forEach(function (step) {
                        let s = StepConfigFactory.getStepPublicConfig(step);
                        steps.push(s);
                    });
                }

                // Fix EWA-30
                let gpsEnabled = false;
                if (scenario.gpsConfig) {
                    gpsEnabled = scenario.gpsConfig.enabled;
                }

                scripts.push(new EQScript(scenario.chainedTestId, scenario.label, scenario.iterations, steps, gpsEnabled));
            });
        }
        return scripts;
    }

    /**
     * Public API to start a new script
     *
     * @param {number} key the script key from config
     * @param {function} callback the callback for progression
     * @param {Map<string,string>} customFields A map of custom fields
     */
    startScript(key, callback, customFields) {
        let scriptEngine = this.scripts.get(key);
        if (scriptEngine && scriptEngine.running) {
            callback(ScriptConst.SCRIPT_FAILED, ScriptConst.NOT_AVAILABLE, "Script is already running");
        } else {
            const scenario = this.foundScenario(this.configuration, key);
            if (scenario) {
                const deviceManager = this.deviceService.manager;

                // Refresh IP
                deviceManager.retrievePrivateIpAddress();

                scriptEngine = new ScriptEngine(this.uid, this.configuration.campaignId, scenario, this.gpsService.gpsManager, deviceManager, callback, customFields, this.configuration.groupId, this.gatewayService);

                this.scripts.set(key, scriptEngine);
                scriptEngine.start();
            } else {
                callback(ScriptConst.SCRIPT_FAILED, ScriptConst.NOT_AVAILABLE, "Scenario not found, the configuration has changed, reload it");
            }
        }
    }

    /**
     * Public API to stop a running script
     *
     * @param {number} key the script key from config
     * @return {boolean} if test will stop, false otherwise
     */
    stopScript(key) {
        let scriptEngine = this.scripts.get(key);
        if (!scriptEngine || !scriptEngine.running) {
            return false;
        }
        return scriptEngine.stop();
    }

    /**
     * Stop all scripts
     */
    stopAll() {
        this.scripts.forEach((value, key) => {
            this.stopScript(key);
        });
    }

    /**
     * Search the scenario from config with the key
     *
     * @param {Config} configuration the server config
     * @param {number} key the scenario key
     * @return {ConfigScenario} the scenario if found, null otherwise
     */
    foundScenario(configuration, key) {
        let tmp = null;
        configuration.scenarios.forEach((scenario) => {
            if (scenario.chainedTestId === key) {
                tmp = scenario;
            }
        });
        return tmp;
    }
}



// WEBPACK FOOTER //
// ./js/core/script/ScriptService.js